/**
 * ISSUE-1057. The composer's PDF gate and refusal copy. PDFs are a real chat
 * attachment kind (C28), capped at the same 15 MB media-api enforces for every
 * original upload (D18 option A). Pure functions, so the hook and the chip
 * never invent a sentence of their own.
 */
import { FILE_TOO_LARGE_COPY } from "@sportsmet/errors";

import {
  COMPOSER_PDF_EMPTY_MESSAGE,
  COMPOSER_PDF_NOT_A_PDF_MESSAGE,
  COMPOSER_PDF_UPLOAD_FAILED_MESSAGE,
  COMPOSER_PDF_UPLOAD_NOT_RECEIVED_MESSAGE,
} from "./chatExtrasCopy";

export const CHAT_PDF_CONTENT_TYPE = "application/pdf" as const;
/** D18 option A, matching media-api's MAX_ORIGINAL_UPLOAD_BYTES. Decimal, not 15 * 1024 * 1024. */
export const MAX_CHAT_PDF_BYTES = 15_000_000;

export type typePdfRefusal = "wrongType" | "tooLarge" | "empty";
export type typePdfUploadFailure = { message: string; canRetry: boolean };

export function validatePdfFile(file: {
  type: string;
  size: number;
}): typePdfRefusal | null {
  if (file.type !== CHAT_PDF_CONTENT_TYPE) return "wrongType";
  if (file.size > MAX_CHAT_PDF_BYTES) return "tooLarge";
  if (file.size < 1) return "empty";
  return null;
}

export function pdfRefusalFailure(
  reason: typePdfRefusal,
): typePdfUploadFailure {
  if (reason === "wrongType") {
    return { message: COMPOSER_PDF_NOT_A_PDF_MESSAGE, canRetry: false };
  }
  if (reason === "tooLarge") {
    return { message: FILE_TOO_LARGE_COPY, canRetry: false };
  }
  return { message: COMPOSER_PDF_EMPTY_MESSAGE, canRetry: false };
}

export function pdfServerFailure(code: string | null): typePdfUploadFailure {
  if (code === "UNSUPPORTED_CONTENT_TYPE") {
    return { message: COMPOSER_PDF_NOT_A_PDF_MESSAGE, canRetry: false };
  }
  if (code === "FILE_TOO_LARGE") {
    return { message: FILE_TOO_LARGE_COPY, canRetry: false };
  }
  if (code === "UPLOAD_NOT_RECEIVED") {
    return {
      message: COMPOSER_PDF_UPLOAD_NOT_RECEIVED_MESSAGE,
      canRetry: true,
    };
  }
  return { message: COMPOSER_PDF_UPLOAD_FAILED_MESSAGE, canRetry: true };
}
